import { render, staticRenderFns } from "./TrainingList.vue?vue&type=template&id=8f0625f8&"
import script from "./TrainingList.vue?vue&type=script&lang=js&"
export * from "./TrainingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports